<template>
  <div class="home">
    <template>
      <b-container class="container-rda sidebar">
        <b-row class="height">
          <sidebar-coordination />
          <b-col class="content">
            <b-row>
              <b-col>
                <Breadcrumb :breadcrumb="breadcrumb" />
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col>
                <h2 class="purple bold">Registrar preço Pititim</h2>
              </b-col>
              <b-col class="text-right"> </b-col>
            </b-row>

            <div class="price-card mb-5">
              <b-row>
                <b-col md="4">
                  <label>Calendário</label>
                  <SelectSingle
                    label=""
                    :options="calendars"
                    :callback="handleCalendar"
                    :initial="selectedCalendar"
                  />
                </b-col>
                <b-col md="4">
                  <label>Preço por módulo</label>
                  <CurrencyInput
                    :value="pricePerModule"
                    @input="pricePerModule = $event"
                  />
                </b-col>
                <b-col md="4">
                  <label>Taxa de material</label>
                  <CurrencyInput v-model="materialFee" />
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col>
                  <label class="discounts-label">Descontos por módulo</label>
                  <div class="discounts-table">
                    <div class="discounts-header">
                      <div class="discounts-col-module">Módulo</div>
                      <div class="discounts-col-discount">Desconto (%)</div>
                      <div class="discounts-col-value">Valor mensal</div>
                    </div>
                    <div
                      v-for="(discount, index) in discounts"
                      :key="index"
                      class="discounts-row"
                    >
                      <div class="discounts-col-module">
                        <span class="module-number">{{ discount.modules }}</span>
                      </div>
                      <div class="discounts-col-discount">
                        <input
                          v-model.number="discount.discount"
                          type="number"
                          class="form-control"
                          step="1"
                          min="0"
                          max="100"
                          placeholder="0"
                          @input="autoFillDiscounts(index)"
                        />
                      </div>
                      <div class="discounts-col-value">
                        {{ formatBRL(calculateMonthly(discount.modules, discount.discount)) }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <b-row>
              <div class="w-100 mt-5"></div>
              <b-col md="4">
                <b-button
                  class="large blue outline"
                  :to="{
                    name: 'mensalidade-escolar',
                  }"
                  >Voltar</b-button
                >
              </b-col>
              <b-col md="4" offset-md="4">
                <b-button
                  @click="savePrice"
                  :class="`large blue ${isValid ? '' : 'disabled'}`"
                  >Salvar</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import CurrencyInput from "@/components/inputs/CurrencyInput.vue";
import SelectSingle from "@/components/inputs/SelectSingle.vue";
import httpRda from "../../../http-rda";
import pititimPricesService from "@/services/pititim-prices.service";
import { formatBRL } from "@/utils/formatBRL";
import { calculateMonthlyPititimPrice } from "@/utils/pititimPrice";

export default {
  name: "create-pititim-price",
  components: {
    CurrencyInput,
    SelectSingle,
  },
  data() {
    return {
      calendars: [],
      selectedCalendar: this.$route.query.calendar
        ? { id: this.$route.query.calendar }
        : null,
      pricePerModule: 0,
      materialFee: null,
      discounts: this.buildInitialDiscounts(),
      isValid: false,
      breadcrumb: [
        {
          text: "Alterações internas",
        },
        {
          text: "Mensalidade escolar",
        },
        {
          text: "Registrar preço Pititim",
        },
      ],
    };
  },

  watch: {
    pricePerModule() {
      this.validate();
    },
    discounts: {
      handler() {
        this.validate();
      },
      deep: true,
    },
    selectedCalendar() {
      this.validate();
    },
  },

  methods: {
    formatBRL,

    calculateMonthly(modules, discount) {
      return calculateMonthlyPititimPrice(modules, this.pricePerModule, discount);
    },

    buildInitialDiscounts() {
      const pattern = [0, 25, 35, 45, 50, 52, 54, 56, 58, 60];
      const discounts = [];
      for (let i = 1; i <= 10; i++) {
        discounts.push({ modules: i, discount: pattern[i - 1] });
      }
      return discounts;
    },

    autoFillDiscounts(index) {
      if (index !== 0) return;
      const pattern = [0, 25, 35, 45, 50, 52, 54, 56, 58, 60];
      for (let i = 1; i < this.discounts.length; i++) {
        this.discounts[i].discount = pattern[i];
      }
    },

    handleCalendar(calendar) {
      this.selectedCalendar = calendar;
    },

    validate() {
      const calendarValid =
        this.selectedCalendar && this.selectedCalendar.id;
      const priceValid = this.pricePerModule > 0;
      const discountsValid =
        this.discounts.length === 10 &&
        this.discounts.every(
          (d) =>
            d.modules >= 1 &&
            d.modules <= 10 &&
            d.discount >= 0 &&
            d.discount <= 100
        );

      this.isValid = calendarValid && priceValid && discountsValid;
    },

    async getCalendars() {
      this.calendars = await httpRda
        .get("/calendars")
        .then((resp) => resp.data.calendars);

      this.calendars = this.calendars.map((calendar) => {
        return {
          id: calendar.id,
          name: calendar.designation,
        };
      });

      if (this.selectedCalendar && this.selectedCalendar.id) {
        this.selectedCalendar = this.calendars.find(
          (c) => +c.id === +this.selectedCalendar.id
        );
      } else if (this.calendars.length > 0) {
        this.selectedCalendar = this.calendars[0];
      }
    },

    async savePrice() {
      this.validate();

      if (!this.isValid) {
        this.$swal.fire({
          icon: "warning",
          title: "Campos obrigatórios",
          text: "Preencha todos os campos corretamente. Calendário é obrigatório, preço deve ser maior que 0 e todos os 10 descontos devem estar preenchidos (0-100%).",
        });
        return;
      }

      const payload = {
        calendar_id: this.selectedCalendar.id,
        price: this.pricePerModule,
        material_fee: this.materialFee || null,
        discounts: this.discounts.map((d) => ({
          modules: d.modules,
          discount: d.discount,
        })),
      };

      try {
        await pititimPricesService.create(payload);

        const Toast = this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: "Preço criado com sucesso!",
        });

        this.$router.push({ name: "mensalidade-escolar" });
      } catch (error) {
        const message =
          (error.response && error.response.data && error.response.data.message) ||
          "Não foi possível criar o preço.";

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: message,
        });
      }
    },
  },

  created() {
    this.getCalendars();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.price-card {
  background-color: $grey2;
  border-radius: 12px;
  padding: 32px 24px;
}

.home {
  height: 100%;
}

.container-rda {
  padding-bottom: 0;
}

label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.discounts-label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.discounts-table {
  width: 100%;
  max-width: 520px;
}

.discounts-header {
  display: flex;
  padding: 8px 0;
  border-bottom: 2px solid $grey5;

  .discounts-col-module,
  .discounts-col-discount,
  .discounts-col-value {
    font-weight: 600;
    font-size: 14px;
    color: #495057;
  }
}

.discounts-row {
  display: flex;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #e7e8ec;

  &:last-child {
    border-bottom: none;
  }
}

.discounts-col-module {
  width: 120px;
  display: flex;
  align-items: center;
}

.module-number {
  font-weight: 600;
  color: #495057;
}

.discounts-col-discount {
  flex: 1;

  .form-control {
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 6px 10px;
    font-size: 14px;
    width: 100%;
    max-width: 120px;

    &:focus {
      border-color: $purple;
      outline: none;
      box-shadow: 0 0 0 0.2rem rgba($purple, 0.15);
    }
  }
}

.discounts-col-value {
  width: 120px;
  text-align: right;
  font-weight: 600;
  font-size: 14px;
  color: $green3;
  padding-right: 8px;
}
</style>
